// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"bfe2a82a","422":"56bfe80a"}[chunkId] + ".chunk.css";
};